import PublicNavar from "../../componet/PublicNavar";

export const Index2 = () => {
    return (
        <>


            <main className="min-h-screen bg-background overflow-x-hidden">
                <PublicNavar />
                {/* <HeroSection />
        <ServicesSection />
        <ClientsSection />
        <NewsSection />
        <ToolsSection />
        <Footer />
        <WhatsAppButton /> */}
            </main>
            <div className="min-h-screen flex items-center justify-center bg-red-500 text-black text-4xl bg-[#25D366]">
                TAILWIND FUNCIONA
            </div><div className="h-14 bg-gradient-to-r from-cyan-500 to-blue-500">dasd</div>
        </>
    )
}
